import { useI18nContext } from '@/i18n/i18n-react';
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { cn } from '@/lib/utils';

export interface AnalyticsDisabledOverlayProps {
  /**
   * `screen` (default): covers the whole content area. `panel`: covers only
   * its positioned parent (the active Analytics tab panel), leaving header,
   * tabs, tab bar and Pedidos free (SALES-04 AC 5).
   */
  scope?: 'screen' | 'panel';
}

export function AnalyticsDisabledOverlay({
  scope = 'screen',
}: AnalyticsDisabledOverlayProps) {
  const { LL } = useI18nContext();

  return (
    <div
      data-analytics-disabled-overlay
      className={cn(
        'bg-gradient-to-b from-background/50 backdrop-blur-[2px] from-20% to-background via-background/75 via-50% to-100% pointer-events-auto flex justify-center',
        scope === 'panel'
          ? 'absolute inset-0 z-40 items-start'
          : 'fixed inset-0 md:left-64 z-[60] items-center'
      )}
      aria-hidden
    >
      <Card
        className={cn(
          'max-w-[60ch]',
          scope === 'panel' && 'sticky top-1/4 mt-16 max-md:mx-4'
        )}
      >
        <CardHeader>
          <CardTitle>{LL.metricsPage.analyticsComingTitle()}</CardTitle>
        </CardHeader>
        <CardContent>
          <CardDescription>
            {LL.metricsPage.analyticsComingBody()}
          </CardDescription>
          <ul className="list-disc list-inside text-sm text-muted-foreground ml-4">
            <li>{LL.metricsPage.analyticsComingListItems.billingHistory()}</li>
            <li>{LL.metricsPage.analyticsComingListItems.averageTicket()}</li>
            <li>
              {LL.metricsPage.analyticsComingListItems.campaignPerformance()}
            </li>
            <li>{LL.metricsPage.analyticsComingListItems.appRoi()}</li>
            <li>{LL.metricsPage.analyticsComingListItems.andMore()}</li>
          </ul>
        </CardContent>
        <CardFooter className="text-sm text-muted-foreground">
          {LL.metricsPage.analyticsComingFooter()}
        </CardFooter>
      </Card>
    </div>
  );
}
